import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header.jsx";
import Sidebar from "../../layouts/Sidebar.jsx";
import { Table } from "antd";
import * as XLSX from "xlsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import ApiService from "../../service/httpService.js";
import AddLocation from "./AddLocation.jsx";
import EditLocation from "./EditLocation.jsx";

const LocationMaster = () => {
  //state management
  const [datasource, setDataSource] = useState([]);
  const [isLoding, setisLoding] = useState(false);
  const [Data, setData] = useState([]);
  const [menu, setMenu] = useState(false);
  const [EditData, setEditData] = useState({});
  const [search, setsearch] = useState("");

  //fetching employee datas
  const fetchLocation = async () => {
    setisLoding(true);
    try {
      const res = await ApiService.getPublic(
        `get_data.php?table=location&authToken=`
      );
      console.log("Location 1", res);
      if (res != null) {
        setDataSource(res);
        setData(res);
        setisLoding(false);
      }
    } catch (err) {
      console.log("error on fetchLocation", err);
      setisLoding(false);
    } finally {
      setisLoding(false);
    }
  };

  useEffect(() => {
    fetchLocation();
    console.log(EditData);
  }, []);

  const handleEditClick = (record) => {
    setEditData(record);
    console.log("record", record);
  };

  const HandleExport = (data) => {
    // Step 1: Convert JSON data to worksheet
    const worksheet = XLSX.utils.json_to_sheet(
      reorderAndFilterKeys(data, [
        "name",
        "longitude",
        "latitude",
        "distance",
        "date_time",
      ])
    );

    // Step 2: Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const now = new Date();
    const pad = (n) => n.toString().padStart(2, "0");

    const formattedDate = `${pad(now.getDate())}-${pad(
      now.getMonth() + 1
    )}-${now.getFullYear()}`;
    const formattedTime = `${pad(now.getHours())}:${pad(
      now.getMinutes()
    )}:${pad(now.getSeconds())}`;

    // Step 3: Write the workbook and trigger download
    XLSX.writeFile(
      workbook,
      `Location_Details_${formattedDate}_${formattedTime}.xlsx`
    );
  };

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const HandleReferesh = () => {
    fetchLocation();
  };

  const handleInput = (event) => {
    const query = event.target.value?.toLowerCase() ?? "";
    setsearch(event.target.value);

    if (!query) {
      setDataSource(Data); // reset if input is empty
      return;
    }

    const result = Data.filter(
      (item) =>
        item.latitude
          .toString()
          .toLowerCase()
          .includes(query) ||
        item.name
          .toString()
          .toLowerCase()
          .includes(query) ||
        item.distance
          .toString()
          .toLowerCase()
          .includes(query) ||
        item.longitude
          .toString()
          .toLowerCase()
          .includes(query)
    );

    setDataSource(result);
  };

  function reorderAndFilterKeys(data, keyOrder) {
    return data.map((obj) => {
      const newObj = {};
      keyOrder.forEach((key) => {
        if (key in obj) {
          newObj[key] = obj[key];
        }
      });
      return newObj;
    });
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <li key={`locate-${record.id}`} className="text-primary ">
          <a
            href={`https://www.google.com/maps?q=${record.latitude},${record.longitude}`}
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-item"
          >
            <i className="fe fe-map-pin me-2" />
            <span className="text-decoration-underline">{record.name}</span>
          </a>
        </li>
      ),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Latitude",
      dataIndex: "latitude",
    },
    {
      title: "Longitude",
      dataIndex: "longitude",
    },
    {
      title: "Distance",
      dataIndex: "distance",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <div>
          {status == 1 && (
            <span className="badge bg-success-light">
              <i className="fe fe-check me-1"></i>Active
            </span>
          )}
          {status == 0 && (
            <span className="badge bg-danger-light">
              <i className="fe fe-x me-1"></i>
              {"Inactive"}
            </span>
          )}
        </div>
      ),
      sorter: (a, b) => a.status - b.status,
    },

    {
      title: "Action",
      dataIndex: "Action",
      render: (text, record) => (
        <div className="table-invoice d-flex align-items-center">
          <div className="dropdown dropdown-action">
            <a
              className="btn-action-icon"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={(e) => e.preventDefault()}
            >
              <i className="fas fa-ellipsis-v" />
            </a>
            <div className="dropdown-menu dropdown-menu-end">
              <ul className="list-unstyled mb-0">
                <li key={`edit-${record.id}`}>
                  <a
                    className="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#Edit_location"
                    onClick={() => {
                      handleEditClick(record);
                    }}
                  >
                    <i className="fe fe-edit me-2" /> Edit
                  </a>
                </li>
                <li key={`locate-${record.id}`}>
                  <a
                    href={`https://www.google.com/maps?q=${record.latitude},${record.longitude}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="dropdown-item"
                  >
                    <i className="fe fe-map-pin me-2" /> Locate
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="content-page-header flex-column gap-3 ">
                <h5>Location Master</h5>
                <div className="page-content">
                  <div className="list-btn">
                    <ul className="filter-list d-flex justify-content-center">
                      <div className="d-flex flex-column flex-md-row gap-md-0">
                        <li>
                          {/* Search */}
                          <form className="m-0">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search"
                              value={search}
                              onChange={datasource && handleInput}
                            />
                          </form>
                          {/* /Search */}
                        </li>

                        {/* referesh function */}
                        <li>
                          <a
                            className="btn-filters p-2"
                            data-bs-toggle="tooltip"
                            data-bs-placement="bottom"
                            title="Refresh"
                            onClick={HandleReferesh}
                          >
                            <span>
                              <i className="fe fe-refresh-ccw pe-1" />
                            </span>
                            Refresh
                          </a>
                        </li>
                      </div>
                      <div className="d-flex gap-2 ">
                        <li>
                          <button
                            className="d-flex align-items-center download-item btn btn-filters"
                            onClick={(e) => {
                              e.preventDefault();
                              datasource && HandleExport(datasource);
                            }}
                          >
                            <i className="far fa-file-text me-2" />
                            Export
                          </button>
                        </li>
                        <li>
                          <a
                            className="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#add_location"
                          >
                            <i
                              className="fa fa-plus-circle me-2"
                              aria-hidden="true"
                            />
                            Add Location
                          </a>
                        </li>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* /Page line */}
            <div className="super-admin-list-head"></div>
            {isLoding ? (
              <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status" />
              </div>
            ) : (
              <div className="row">
                <div className="col-sm-12 ">
                  <div className="card-table">
                    <div className="card-body">
                      <div className="table-responsive">
                        <Table
                          style={{ background: "transparent" }}
                          pagination={{
                            total: datasource && datasource.length,
                            showSizeChanger: true,
                            // onShowSizeChange: onShowSizeChange,
                            // itemRender: itemRender,
                          }}
                          rowKey="id"
                          columns={columns}
                          dataSource={datasource}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <AddLocation fetchLocation={fetchLocation} />
      <EditLocation Emp_data={EditData} fetchLocation={fetchLocation} />
    </div>
  );
};

export default LocationMaster;
